// src/data/serumsImg/ayurvedaImages.js

export const ayurvedaSetImages = {
  imgBanner: require("../../img/jetCare-serums/Opening_pages_Ayurveda.png"),
  imgModal: require("../../img/jetCare-serums/Ayurveda_Set.png"),
  productsImages: {
    "jetCare-ayurveda-exfoliation": {
      image: require("../../img/jetCare-serums/JetCare Ayurveda Exfoliation.png"),
      imageBig: require("../../img/jetCare-serums/Ayrveda_Exfolation.png"),
    },
    "jetCar-ayurveda-infusion": {
      image: require("../../img/jetCare-serums/JetCare Ayurveda Infusion.png"),
      imageBig: require("../../img/jetCare-serums/Infusion.png"),
    },
    "jetCare-ayurveda-boost-infusion": {
      image: require("../../img/jetCare-serums/JetCare Ayurveda Boost Infusion.png"),
      imageBig: require("../../img/jetCare-serums/Ayurveda_Boost_Infusion.png"),
    },
  }
};
